import { useHistory } from 'react-router';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { adminAxios } from '../../admin.api';
import { OPERATIONAL_THIRD_PARTY } from '../../queryKeys';
import * as utils from 'utils';
import config from 'config';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useDeleteOperationalThirdParty = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const history = useHistory();

  const handleSettled = () => {
    dispatch(hideModal());
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useDeleteOperationalThirdParty',
      message: 'Data missing for DELETE request',
    };
    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    err?.response?.data?.message
      ? dispatch(enqueueNotification(err?.response?.data?.message, 'error'))
      : dispatch(enqueueNotification('notification.admin.deleteOperationalClientFail', 'error'));
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_THIRD_PARTY);
    history.push(config.routes.admin.operationalThirdParty);

    dispatch(
      enqueueNotification('notification.admin.deleteOperationalTpaSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
  };

  return useMutation(
    async (id) => {
      return await adminAxios.delete(`v1/operational-third-party/${id}`);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
